import React from "react";
import get from 'lodash/get';
import { PublicFieldProps, useRecordContext } from 'react-admin';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import MopedIcon from '@mui/icons-material/Moped';
import { Grid } from "@mui/material";

const DeliveryMethodsField: React.FC<PublicFieldProps> = (props: any) => {
  const { source } = props;
  const record = useRecordContext(props);
  if (!record) return null;
  const deliveryMethods: string[] = get(record, source);

  const methodToElement: Record<string, JSX.Element> = {
    'car': <Grid item key='car'><DirectionsCarIcon></DirectionsCarIcon></Grid>,
    'bike': <Grid item key='bike'><DirectionsBikeIcon></DirectionsBikeIcon></Grid>,
    'foot': <Grid item key='foot'><DirectionsWalkIcon></DirectionsWalkIcon></Grid>,
    'moped': <Grid item key='moped'><MopedIcon></MopedIcon></Grid>,
  }

  return (<Grid container direction={'row'} spacing={1}>
    {deliveryMethods?.map((method: string) => methodToElement[method])}
  </Grid>);
}

DeliveryMethodsField.defaultProps = {
  addLabel: true,
}

export default DeliveryMethodsField;